'use client';

import React, { createContext, useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSamplerCart } from '../../shopify/useSamplerCart';

const defaultCartState = {
  cartId: null,
  couponCode: null,
  isLoading: false,
  isFetchingOfferFlags: false,
  addPromo: offerCode => Promise.resolve(null),
};

export const SamplerCartContext = createContext(defaultCartState);

export const resolveSamplerCartFlags = (isReady, pathname) => {
  if (!isReady) {
    return { shouldCreateCart: false, hasCheckedPath: false };
  }

  return {
    shouldCreateCart: Boolean(pathname?.includes('/sampler-box')),
    hasCheckedPath: true,
  };
};

export const SamplerCartProvider = ({ children }) => {
  const router = useRouter();
  const [shouldCreateCart, setShouldCreateCart] = useState(false);
  const [hasCheckedPath, setHasCheckedPath] = useState(false);

  useEffect(() => {
    const { shouldCreateCart: createCart, hasCheckedPath: checkedPath } =
      resolveSamplerCartFlags(router.isReady, router.pathname);
    setShouldCreateCart(createCart);
    setHasCheckedPath(checkedPath);
  }, [router.isReady, router.pathname]);

  const cartState = useSamplerCart({
    shouldCreateCart,
    hasCheckedPath,
  });

  return (
    <SamplerCartContext.Provider value={cartState}>
      {children}
    </SamplerCartContext.Provider>
  );
};
export const useSamplerCartContext = () => {
  const context = useContext(SamplerCartContext);
  if (!context) {
    // Shopify TODO: remove this once we have production validated
    // eslint-disable-next-line no-console
    console.warn(
      'useSamplerCartContext called outside of SamplerCartProvider, using fallback values',
    );
  }

  return context;
};
